// extracted by mini-css-extract-plugin
export default {"experience_section":"Experience_experience_section__V6rqF","experience_list":"Experience_experience_list__ouytl"};